"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteCommentData = exports.CreateCommentData = exports.jsonPathSchema = exports.COMMENT_DATA_FIELDS = exports.COMMENT_OBJECT_TYPES = void 0;
const zod_1 = require("zod");
const MAX_COMMENT_LENGTH = 5000;
exports.COMMENT_OBJECT_TYPES = [
    "TRACE",
    "OBSERVATION",
    "SESSION",
    "PROMPT",
];
exports.COMMENT_DATA_FIELDS = ["input", "output", "metadata"];
// JSON Path validation
// TODO: simplify
// Allows: $ (root), $.foo, $[0], $.foo[0].bar, $['key-with-dash'], etc.
exports.jsonPathSchema = zod_1.z
    .string()
    .regex(/^\$(\.[a-zA-Z_][a-zA-Z0-9_-]*|\[\d+\]|\['[^']+'\]|\["[^"]+"\])*$/, "Invalid JSON Path syntax");
exports.CreateCommentData = zod_1.z
    .object({
    projectId: zod_1.z.string(),
    content: zod_1.z.string().trim().min(1).max(MAX_COMMENT_LENGTH),
    objectId: zod_1.z.string(),
    objectType: zod_1.z.enum(exports.COMMENT_OBJECT_TYPES),
    // Optional inline positioning (parallel arrays)
    dataField: zod_1.z.enum(exports.COMMENT_DATA_FIELDS).nullish(),
    path: zod_1.z.array(exports.jsonPathSchema).nullish(),
    rangeStart: zod_1.z.array(zod_1.z.number().int().min(0)).nullish(),
    rangeEnd: zod_1.z.array(zod_1.z.number().int().min(1)).nullish(),
})
    .refine((data) => {
    const hasDataField = data.dataField != null;
    const hasPath = data.path != null && data.path.length > 0;
    const hasRangeStart = data.rangeStart != null && data.rangeStart.length > 0;
    const hasRangeEnd = data.rangeEnd != null && data.rangeEnd.length > 0;
    // All must be set together, or all must be null/empty
    if (hasDataField || hasPath || hasRangeStart || hasRangeEnd) {
        return (hasDataField &&
            hasPath &&
            hasRangeStart &&
            hasRangeEnd &&
            data.path.length === data.rangeStart.length &&
            data.path.length === data.rangeEnd.length);
    }
    return true;
}, {
    message: "dataField, path, rangeStart, rangeEnd must all be set together with matching lengths, or all be null/empty",
})
    .refine((data) => {
    // Validate each range: start must be < end
    if (data.rangeStart && data.rangeEnd) {
        return data.rangeStart.every((start, i) => start < data.rangeEnd[i]);
    }
    return true;
}, { message: "Each rangeStart must be less than corresponding rangeEnd" });
exports.DeleteCommentData = zod_1.z.object({
    projectId: zod_1.z.string(),
    commentId: zod_1.z.string(),
    objectId: zod_1.z.string(),
    objectType: zod_1.z.enum(exports.COMMENT_OBJECT_TYPES),
});
